import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { Button } from '@material-ui/core'
// import { makeStyles } from '@material-ui/core/styles'
// import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import PublicCourseHeader from '../publicCourse/PublicCourseHeader'
import BoughtCourseCard from './BoughtCourseCard'
import {
  selectorPublicCoursesGroup, getCoursesGroup, selectorCourseGroup, selectorLessons,
  getCourseGroup, getLessons,
} from '../../../app/slices/courseSlice'

const BoughtCourseDetails = ({ bought, professional, admin }) => {
  const cources = useSelector(selectorPublicCoursesGroup)
  const dispatch = useDispatch()
  const course = useSelector(selectorCourseGroup)
  const lessons = useSelector(selectorLessons)
  const role = useSelector((state) => state.user?.role)
  const { id } = useParams()

  useEffect(() => {
    dispatch(getCoursesGroup())
    dispatch(getCourseGroup(id))
    dispatch(getLessons({ UserId: '207', CourseGroupId: id, first: '100' }))
  }, [id])

  console.log(cources)
  return (
    <div>
      {[1].includes(role?.roleId) && <PublicCourseHeader expireDate={course?.expireDate} />}
      <BoughtCourseCard
        course={course}
        lessons={lessons}
        bought={bought}
        professional={professional}
        admin={admin}
      />
    </div>
  )
}

export default BoughtCourseDetails
